// extracted by mini-css-extract-plugin
module.exports = {"loader":"Loader_loader__2DtNW","loaderWhite":"Loader_loaderWhite__2evQ9","loader-white":"Loader_loader-white__qKmb4"};